import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
import React, { useContext, useEffect, useState } from 'react';
import { Dimensions, Image, Text, TouchableOpacity, View } from 'react-native';
import { Button } from '../../Button/rn';
import { Popup } from '../../Popup/rn';
import { Transaction } from '../../Transaction/rn';
import { OtherMoreTransactionList } from './OtherMoreTransactionList';
import { useLocale } from '../../LocaleProvider/rn';
import { LABEL_WITHDRAWAL, LABEL_TOPUP } from '../../../utils/constants';
import { ScrollType, TrackerScope, TrackerScrollView, useComponentTracking } from '../../../hooks/rn/useTracking';
import { ConfigContext } from '../../ConfigProvider/rn/context'; // import { ElementScrollTrackManage, ScrollType } from '../../../utils/tracking/elementScrollTrack';

import moreOrderImageCard from '../../../assets/images/ic_cbot_topup.png';
import moreOrderImageBank from '../../../assets/images/ic_cbot_withdrawID.png';
import iconTransactionBank from '../../../assets/images/cb_ic_withdraw.png';
import iconTransactionCard from '../../../assets/images/cb_ic_topup.png';
import styles from './styles'; // TODO: tracking

export var TransactionType;
(function (TransactionType) {
  TransactionType[TransactionType["Topup"] = 2] = "Topup";
  TransactionType[TransactionType["Withdrawal"] = 3] = "Withdrawal";
})(TransactionType || (TransactionType = {}));
export var TransactionList = function TransactionList(props) {
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    showTime = _useState2[0],
    setShowTime = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPopup = _useState4[0],
    setShowPopup = _useState4[1]; // const containerRef = useRef(null);

  var hasMoreTransaction = props.hasMoreTransaction,
    _props$content = props.content,
    content = _props$content === void 0 ? [] : _props$content,
    loadMoreTransactionText = props.loadMoreTransactionText,
    selectTransactionText = props.selectTransactionText,
    type = props.type,
    action = props.action,
    onLoadMore = props.onLoadMore,
    _props$maxDisplay = props.maxDisplay,
    maxDisplay = _props$maxDisplay === void 0 ? 5 : _props$maxDisplay,
    panelTitleText = props.panelTitleText,
    _onTransactionCardClick = props.onTransactionCardClick,
    componentTrackingData = props.componentTrackingData,
    usePresetStatusMap = props.usePresetStatusMap; // const elementScrollTrack = new ElementScrollTrackManage();

  var _useComponentTracking = useComponentTracking(_objectSpread(_objectSpread({}, props), {}, {
      scope: TrackerScope.TransactionList
    })),
    tracker = _useComponentTracking.tracker,
    result = _useComponentTracking.result;
  var moreTransactionTracking = result.moreTransaction,
    donNotSeeTransactionTracking = result.donNotSeeTransaction,
    transactionListTrackData = result.transactionList,
    closePanelTrackingData = result.closePanel;
  var trackingData = componentTrackingData && {
    panelDoNotSeeTransaction: componentTrackingData === null || componentTrackingData === void 0 ? void 0 : componentTrackingData.panelDoNotSeeTransaction,
    panelTransaction: componentTrackingData === null || componentTrackingData === void 0 ? void 0 : componentTrackingData.panelTransaction
  };
  var context = useContext(ConfigContext);
  var _useLocale = useLocale(),
    trans = _useLocale.trans;
  var title = panelTitleText ? panelTitleText : type === TransactionType.Withdrawal ? trans(LABEL_WITHDRAWAL) : trans(LABEL_TOPUP);
  var image = type === TransactionType.Topup ? iconTransactionCard : iconTransactionBank;
  var transactionItemDisplayNumber = Math.min(content.length, maxDisplay);
  var handleMoreOrderClick = function handleMoreOrderClick() {
    (moreTransactionTracking === null || moreTransactionTracking === void 0 ? void 0 : moreTransactionTracking.trackingClick) && tracker.click(moreTransactionTracking.trackingClick);
    setShowPopup(true);
  };
  var renderTransactionItem = function renderTransactionItem(props) {
    var _transaction$action;
    var transaction = props.transaction,
      index = props.index;
    if (transaction !== null && transaction !== void 0 && (_transaction$action = transaction.action) !== null && _transaction$action !== void 0 && _transaction$action.info) {
      transaction.action.info.image = image;
    }
    var _useComponentTracking2 = useComponentTracking({
        // @ts-ignore
        componentTrackingData: {
          transaction: componentTrackingData === null || componentTrackingData === void 0 ? void 0 : componentTrackingData.transaction
        },
        componentData: {
          transaction: transaction,
          index: index
        },
        scope: TrackerScope.TransactionList
      }),
      tracker = _useComponentTracking2.tracker,
      transactionTracking = _useComponentTracking2.result.transaction;
    var handleCardClick = function handleCardClick() {
      (transactionTracking === null || transactionTracking === void 0 ? void 0 : transactionTracking.trackingClick) && tracker.click(transactionTracking.trackingClick);
    };
    return /*#__PURE__*/React.createElement(View, _extends({
      key: "transaction-".concat(index),
      style: [styles.transactionItem, !hasMoreTransaction && index === transactionItemDisplayNumber - 1 && {
        marginRight: 0
      }]
    }, transactionTracking === null || transactionTracking === void 0 ? void 0 : transactionTracking.trackingImpressionProps), /*#__PURE__*/React.createElement(Transaction, _extends({}, transaction, {
      image: image,
      usePresetStatusMap: usePresetStatusMap,
      onClick: handleCardClick
    })), /*#__PURE__*/React.createElement(Button, {
      action: transaction.action,
      text: selectTransactionText
    }));
  };
  var handleNoMoreTransactionClick = function handleNoMoreTransactionClick() {
    (donNotSeeTransactionTracking === null || donNotSeeTransactionTracking === void 0 ? void 0 : donNotSeeTransactionTracking.trackingClick) && tracker.click(donNotSeeTransactionTracking.trackingClick);
    console.log('handleNoMoreTransactionClick', handleNoMoreTransactionClick);
  };
  var renderHasMoreBtn = function renderHasMoreBtn(props) {
    var loadMoreTransactionText = props.loadMoreTransactionText,
      type = props.type;
    return /*#__PURE__*/React.createElement(TouchableOpacity, _extends({
      style: styles.moreBtn,
      onPress: handleMoreOrderClick
    }, moreTransactionTracking === null || moreTransactionTracking === void 0 ? void 0 : moreTransactionTracking.trackingImpressionProps), /*#__PURE__*/React.createElement(Image, {
      style: styles.moreBtnImage,
      source: type === TransactionType.Topup ? moreOrderImageCard : moreOrderImageBank
    }), /*#__PURE__*/React.createElement(Text, {
      style: styles.moreBtnText
    }, loadMoreTransactionText));
  };
  var renderStillNotSee = function renderStillNotSee(props) {
    var _useComponentTracking3 = useComponentTracking({
        componentTrackingData: componentTrackingData
      }),
      tracker = _useComponentTracking3.tracker,
      donNotSeeTransactionTracking = _useComponentTracking3.result.donNotSeeTransaction;
    return /*#__PURE__*/React.createElement(View, {
      style: styles.transactionConsult
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.consultMessage
    }, props.transactionContent), /*#__PURE__*/React.createElement(TouchableOpacity, {
      onPress: function onPress() {
        var _context$eventEmitter, _props$checkHereActio;
        context === null || context === void 0 ? void 0 : (_context$eventEmitter = context.eventEmitter) === null || _context$eventEmitter === void 0 ? void 0 : _context$eventEmitter.emit('next', {
          text: props === null || props === void 0 ? void 0 : props.checkHereContent,
          action: _objectSpread(_objectSpread({}, props.checkHereAction), {}, {
            _actualText_: props === null || props === void 0 ? void 0 : props.checkHereContent,
            nextParams: _objectSpread(_objectSpread({}, props === null || props === void 0 ? void 0 : (_props$checkHereActio = props.checkHereAction) === null || _props$checkHereActio === void 0 ? void 0 : _props$checkHereActio.nextParams), {}, {
              message_text: props === null || props === void 0 ? void 0 : props.checkHereContent
            })
          })
        });
        (donNotSeeTransactionTracking === null || donNotSeeTransactionTracking === void 0 ? void 0 : donNotSeeTransactionTracking.trackingClick) && tracker.click(donNotSeeTransactionTracking === null || donNotSeeTransactionTracking === void 0 ? void 0 : donNotSeeTransactionTracking.trackingClick);
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: styles.consultLink
    }, props.checkHereContent)));
  };
  var transactionScrollTrackHandler = function transactionScrollTrackHandler() {
    console.log('触发滚动上报', transactionListTrackData === null || transactionListTrackData === void 0 ? void 0 : transactionListTrackData.trackingScroll, transactionListTrackData);
    if (transactionListTrackData !== null && transactionListTrackData !== void 0 && transactionListTrackData.trackingScroll) {
      tracker.scroll(transactionListTrackData.trackingScroll);
    }
  };
  useEffect(function () {
    if (showPopup) {
      setShowTime(Date.now());
      return;
    }
    if (!showPopup && showTime && closePanelTrackingData !== null && closePanelTrackingData !== void 0 && closePanelTrackingData.trackingClick) {
      var _closePanelTrackingDa;
      var _trackingData = _objectSpread(_objectSpread({}, (closePanelTrackingData === null || closePanelTrackingData === void 0 ? void 0 : (_closePanelTrackingDa = closePanelTrackingData.trackingClick) === null || _closePanelTrackingDa === void 0 ? void 0 : _closePanelTrackingDa.data) || {}), {}, {
        view_duration: Math.floor((Date.now() - showTime) / 1000)
      });
      tracker.click(_objectSpread(_objectSpread({}, closePanelTrackingData === null || closePanelTrackingData === void 0 ? void 0 : closePanelTrackingData.trackingClick), {}, {
        data: _trackingData
      }));
      setShowTime(0);
    }
  }, [showPopup]);
  return /*#__PURE__*/React.createElement(View, null, /*#__PURE__*/React.createElement(Popup, {
    title: title,
    showCloseIcon: true,
    active: showPopup,
    onClose: function onClose() {
      return setShowPopup(false);
    },
    titleStyle: {
      textAlign: 'center'
    },
    contentContainerStyle: {
      height: Dimensions.get('window').height * 0.8
    },
    contentStyle: [{
      padding: 0
    }],
    contentScrollable: false,
    delayBeforeContentShow: 300
  }, /*#__PURE__*/React.createElement(OtherMoreTransactionList, {
    type: type,
    loadMoreFn: onLoadMore,
    selectTransactionText: selectTransactionText,
    action: action,
    onTransactionCardClick: function onTransactionCardClick(params) {
      setShowPopup(false);
      _onTransactionCardClick === null || _onTransactionCardClick === void 0 ? void 0 : _onTransactionCardClick(params);
    },
    componentTrackingData: trackingData,
    stillNotFoundContent: props === null || props === void 0 ? void 0 : props.stillNotFoundContent,
    checkHereAction: props === null || props === void 0 ? void 0 : props.checkHereAction,
    onClose: function onClose() {
      return setShowPopup(false);
    },
    usePresetStatusMap: usePresetStatusMap
  })), /*#__PURE__*/React.createElement(TrackerScrollView, {
    scope: TrackerScope.TransactionList,
    horizontal: true,
    showsHorizontalScrollIndicator: false,
    contentContainerStyle: styles.transactionList,
    scrollTrackOptions: {
      type: ScrollType.Horizontal,
      scrollCallback: transactionScrollTrackHandler
    }
  }, content.map(function (transaction, index) {
    return index < maxDisplay && renderTransactionItem({
      transaction: transaction,
      index: index
    });
  }), hasMoreTransaction && renderHasMoreBtn({
    loadMoreTransactionText: loadMoreTransactionText,
    type: type
  })), content.length >= 1 && renderStillNotSee({
    transactionContent: props.transactionContent,
    checkHereContent: props === null || props === void 0 ? void 0 : props.checkHereContent,
    checkHereAction: props === null || props === void 0 ? void 0 : props.checkHereAction
  }));
};